// export const getCurrentWeek = function (datum = new Date()) {
//     const day_miliseconds = 86400000,
//         onejan = new Date(datum.getFullYear(), 0, 1, 0, 0, 0),
//         onejan_day = onejan.getDay() === 0 ? 7 : onejan.getDay(),
//         days_for_next_monday = 8 - onejan_day,
//         onejan_next_monday_time =
//             onejan.getTime() + days_for_next_monday * day_miliseconds,
//         // If one jan is not a monday, get the first monday of the year
//         first_monday_year_time =
//             onejan_day > 1 ? onejan_next_monday_time : onejan.getTime(),
//         this_date = new Date(
//             datum.getFullYear(),
//             datum.getMonth(),
//             datum.getDate(),
//             0,
//             0,
//             0
//         ),
//         this_time = this_date.getTime(),
//         days_from_first_monday = Math.round(
//             (this_time - first_monday_year_time) / day_miliseconds
//         );

//     return days_from_first_monday >= 0 && days_from_first_monday < 364
//         ? Math.ceil((days_from_first_monday + 1) / 7)
//         : 52;
// };

function getISOWeekNumber(date: Date): number {
    const target = new Date(date);
    target.setDate(target.getDate() - ((target.getDay() + 6) % 7) + 3); // Move to the nearest Thursday
    const firstThursday = new Date(target.getFullYear(), 0, 4);
    const diff = target.getTime() - firstThursday.getTime();
    const weekNumber = 1 + Math.round(diff / (7 * 86400000));
    return weekNumber;
}

export const getCurrentWeek = function (date = new Date()) {
    return getISOWeekNumber(date);
};

export function getMonday(inputDay: Date) {
    const day = inputDay.getDay(),
        diff = inputDay.getDate() - day + (day === 0 ? -6 : 1);
    return new Date(inputDay.setDate(diff));
}

export function has53Weeks(year: number) {
    let firstDay = new Date(year, 0, 1).getDay(); // Get first day of the year (0 = Sunday, 1 = Monday, ..., 6 = Saturday)
    let isLeapYear = (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;

    return firstDay === 4 || (isLeapYear && firstDay === 3); // Thursday (4) or Wednesday (3) in a leap year
}
